import { render, staticRenderFns } from "./TransportOrderDetail.vue?vue&type=template&id=a0f2d3a4&scoped=true"
import script from "./TransportOrderDetail.vue?vue&type=script&lang=js"
export * from "./TransportOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./TransportOrderDetail.vue?vue&type=style&index=0&id=a0f2d3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f2d3a4",
  null
  
)

export default component.exports